import React, { useEffect, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import API_ASISTENCIA from '../../../componentes/config/apisAsistencia_Variables';
import axios from 'axios';
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
const ModalPuestosFijos = ({ show, close , setSelectedPuestoFijo , setSelectedCataCHSecpolicial,setSelectedCataCHJurpolicial}) => {
    const [puestosFijos, setPuestosFijos] = useState([])
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!loading) {
          // Destruir el DataTable existente antes de inicializar uno nuevo
          const table = $("#tablaPuestosFijos").DataTable();
          if ($.fn.DataTable.isDataTable(table)) {
            table.destroy();
          }
          $.extend(true, $.fn.dataTable.defaults, {
            language: {
              sProcessing: "Procesando...",
              sLengthMenu: "Mostrar _MENU_ registros",
              sZeroRecords: "No se encontraron resultados",
              sEmptyTable: "Ningún dato disponible en esta tabla",
              sInfo:
                "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
              sInfoEmpty:
                "Mostrando registros del 0 al 0 de un total de 0 registros",
              sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
              sInfoPostFix: "",
              sSearch: "Buscar:",
              sUrl: "",
              sInfoThousands: ",",
              sLoadingRecords: "Cargando...",
              oPaginate: {
                sFirst: "Primero",
                sLast: "Último",
                sNext: "Siguiente",
                sPrevious: "Anterior",
              },
              oAria: {
                sSortAscending:
                  ": Activar para ordenar la columna de manera ascendente",
                sSortDescending:
                  ": Activar para ordenar la columna de manera descendente",
              },
              buttons: {
                copy: "Copiar",
                colvis: "Visibilidad",
              },
            },
          });
    
          // Inicializar el DataTable
          $("#tablaPuestosFijos").DataTable();
        }
      }, [loading, show]);
      const handleSeleccionarPuestoFijo = (accion , sector ,jur ) => {
        setSelectedPuestoFijo(accion);
        setSelectedCataCHSecpolicial(sector)
        setSelectedCataCHJurpolicial(jur)
        close(); 
      };
    const obtenerPuestosFijos = async () => {
        try {
          setLoading(true);
          const respuesta = await axios.get(
            API_ASISTENCIA["puestosFijos"]
          );
          setPuestosFijos(respuesta.data);
          console.log(respuesta.data);
        } catch (error) {
          console.error("Error al obtener los datos:", error);
        } finally {
          setLoading(false);
        }
      };
      useEffect(() => {
        setLoading(true);
        obtenerPuestosFijos();
      }, []);
  return (
    <Modal show={show} onHide={close} centered dialogClassName="modal-xl" className='font-responsive'>
                      <Modal.Header closeButton className="bg-success text-center">
                <Modal.Title style={{ "color": "#fff" }}>Puestos Fijos </Modal.Title>
              </Modal.Header>
              <Modal.Body className="tabladedatos">
              {loading ? (
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          </div>
        ) : (

              <div className="table-responsive">
                <table
                  id="tablaPuestosFijos"
                  className="table table-striped text-center"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                    <th className='text-center'>Direccion</th>
                      <th className='text-center'>Jurisdicción</th>
                      <th className='text-center'>Sector</th>
                      <th className='text-center'>Seleccionar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {puestosFijos !== null &&
                      puestosFijos.map((index) => (
                        <tr >
                          <td>{index.cata_CH_Nomcatarec}</td>
                          <td>{index.cata_CH_Jurpolicial}</td>
                          <td>{index.cata_CH_Secpolicial}</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-success btn-sm btnseleccionar"
                              title="Seleccionar Acción"
                              style={{fontSize:'10px',width:'50%',margin:'auto'}}
                              onClick={() => handleSeleccionarPuestoFijo(index , index.cata_CH_Secpolicial ,index.cata_CH_Jurpolicial)}
                            >
                              Seleccionar
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
        )}
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-end">


                <Button variant="danger" onClick={close}>
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
  )
}

export default ModalPuestosFijos
